export const teams = [
    '薄荷芝士派',
    '百词斩',
    '未来技能'
]

export const fans = [
    {
        label: '<1W',
        value: [undefined, 10000]
    },
    {
        label: '1W-5W',
        value: [10000, 50000]
    },
    {
        label: '5W-10W',
        value: [50000, 100000]
    },
    {
        label: '10W-20W',
        value: [100000, 200000]
    },
    {
        label: '20W-50W',
        value: [200000, 500000]
    },
    {
        label: '50W-100W',
        value: [500000, 1000000]
    },
    {
        label: '>100W',
        value: [1000000, undefined]
    }
]
// ['MCN', '平台充值', '简易付款', '兼职外包']
export const put_in_types = [
    {
        label: 'MCN',
        value: 'mcn'
    },
    {
        label: '平台充值',
        value: 'recharge'
    },
    {
        label: '简易付款',
        value: 'simple_payment'
    },
    {
        label: '兼职外包',
        value: 'outsource'
    },
    {
        label: '免费',
        value: 'free'
    },
]

export const publish_form_list = [
    {
        label: '直播',
        value: '直播'
    },
    {
        label: '视频',
        value: '视频'
    },
    {
        label: '图文',
        value: '图文'
    },
    {
        label: '动态',
        value: '动态'
    },
    {
        label: '问答',
        value: '问答'
    },
    {
        label: '文章',
        value: '文章'
    },
    {
        label: '泛话题',
        value: '泛话题'
    },
    {
        label: '垂直话题',
        value: '垂直话题'
    },
    {
        label: '垂类',
        value: '垂类'
    },
    {
        label: '链接',
        value: '链接'
    },
    {
        label: '图片',
        value: '图片'
    },
    {
        label: '转发',
        value: '转发'
    }
]


export const service_in_types = [
    {
        label: '增值',
        value: 'value_added'
    },
    {
        label: '返点',
        value: 'rebate'
    },
    {
        label: '追加',
        value: 'addition'
    }
]